<template>
<WindowForView :id="id" ref="Window">
	<div slot="head" class="head bdSub-bottom">
		<span class="title mt05x fs12x">{{getLanguageStr('plant288','实时详情数据')}}</span>
		<div class="fR cField fField hover-f-main_E hover-c-main_E tra-fast_E vaM_E">
			<button class="close close-ico bgClose style-close tra-fast hover-f-error" :title="$t('cmd153',['关闭'])" @click="close" type="button"><svg class="ico"><use xlink:href="#ico-close" /></svg></button>
		</div>
	</div>
	<div v-show="JSON.stringify(Data) !='{}'" class="emptyToken_EE realTimeInfo textCut_EE">
		<div  fillHeight="lastHeight" scroll>
			<table>
				<thead>
					<tr>
						<th class="w10x"></th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="pt2x vaT vaM_E">
							<svg class="w3x h3x ml2x">
								<use xlink:href="#ico-getPower"></use>
							</svg>
							<span>{{$t('word978',['发电'])}}</span>
						</td>
						<td>
							<ul class="bdSub-bottom">
								<li>
									<div class="cMain" :title="$t('word176',['发电功率'])">{{$t('word176',['发电功率'])}}</div>
									<div class="cMain">
										<span :title="convertData(Data.generationPower,2,'','W')[0]"><span class="fs16x">{{convertData(Data.generationPower,2,"","W")[1]}}</span>{{convertData(Data.generationPower,2,"","W")[2]}}</span>
									</div>
								</li>
								<li style="width:auto">
									<div class="cSub" :title="getLanguageStr('plant289','当月日均满发小时数')">{{getLanguageStr('plant289','当月日均满发小时数')}}</div>
									<div :title="floatFix(Data.fullPowerAvgHours,2,' h')">
										<span class="fs16x">{{floatFix(Data.fullPowerAvgHours,2)}}</span>
										<span v-if="Data.fullPowerAvgHours">h</span>
									</div>
								</li>
							</ul>
							<ul class="bdSub-bottom">
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word358',['当日发电量'])">
										<span class="dpB" >{{$t('word358',['当日发电量'])}}</span>
									</div>
									<div :title="convertData(Data.generationToday,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.generationToday,2,"k","Wh")[1]}}</span>{{convertData(Data.generationToday,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word359',['当月发电量'])">
										<span class="dpB" >{{$t('word359',['当月发电量'])}}</span>
									</div>
									<div :title="convertData(Data.generationMonth,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.generationMonth,2,"k","Wh")[1]}}</span>{{convertData(Data.generationMonth,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant290','当季发电量')">
										<span class="dpB" >{{getLanguageStr('plant290','当季发电量')}}</span>
									</div>
									<div :title="convertData(Data.generationQuarter,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.generationQuarter,2,"k","Wh")[1]}}</span>{{convertData(Data.generationQuarter,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word360',['当年发电量'])">
										<span class="dpB" >{{$t('word360',['当年发电量'])}}</span>
									</div>
									<div :title="convertData(Data.generationYear,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.generationYear,2,"k","Wh")[1]}}</span>{{convertData(Data.generationYear,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word357',['累计发电量'])">
										<span class="dpB" >{{$t('word357',['累计发电量'])}}</span>
									</div>
									<div :title="convertData(Data.generationUpload,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.generationUpload,2,"k","Wh")[1]}}</span>{{convertData(Data.generationUpload,2,"k","Wh")[2]}}</div>
								</li>
							</ul>
						</td>
					</tr>
					<tr>
						<td class="pt2x vaT vaM_E">
							<svg class="w3x h3x ml2x"><use xlink:href="#ico-house-useElectricity"></use></svg>
							<span>{{$t('word561',['用电'])}}</span>
						</td>
						<td>
							<ul class="bdSub-bottom">
								<li>
									<div class="cMain" :title="$t('word977',['用电功率'])">{{$t('word977',['用电功率'])}}</div>
									<div class="cMain">
										<span :title="convertData(Data.consumptionPower,2,'','W')[0]"><span class="fs16x">{{convertData(Data.consumptionPower,2,"","W")[1]}}</span>{{convertData(Data.consumptionPower,2,"","W")[2]}}</span>
									</div>
								</li>
							</ul>
							<ul class="bdSub-bottom">
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word527',['当日用电量'])">
										<span class="dpB" >{{$t('word527',['当日用电量'])}}</span>
									</div>
									<div :title="convertData(Data.consumptionToday,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.consumptionToday,2,"k","Wh")[1]}}</span>{{convertData(Data.consumptionToday,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word528',['当月用电量'])">
										<span class="dpB" >{{$t('word528',['当月用电量'])}}</span>
									</div>
									<div :title="convertData(Data.consumptionMonth,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.consumptionMonth,2,"k","Wh")[1]}}</span>{{convertData(Data.consumptionMonth,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant291','当季用电量')">
										<span class="dpB" >{{getLanguageStr('plant291','当季用电量')}}</span>
									</div>
									<div :title="convertData(Data.consumptionQuarter,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.consumptionQuarter,2,"k","Wh")[1]}}</span>{{convertData(Data.consumptionQuarter,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word529',['当年用电量'])">
										<span class="dpB" >{{$t('word529',['当年用电量'])}}</span>
									</div>
									<div :title="convertData(Data.consumptionYear,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.consumptionYear,2,"k","Wh")[1]}}</span>{{convertData(Data.consumptionYear,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word526',['累计用电量'])">
										<span class="dpB" >{{$t('word526',['累计用电量'])}}</span>
									</div>
									<div :title="convertData(Data.consumptionUpload,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.consumptionUpload,2,"k","Wh")[1]}}</span>{{convertData(Data.consumptionUpload,2,"k","Wh")[2]}}</div>
								</li>
							</ul>
						</td>
					</tr>
					<tr>
						<td class="pt2x vaT vaM_E">
							<svg class="w3x h3x ml2x"><use xlink:href="#ico-eTower"></use></svg>
							<span>{{$t('word162',['并网'])}}</span>
						</td>
						<td>
							<ul class="bdSub-bottom">
								<li>
									<div class="cMain" :title="$t('word190',['电网功率'])">{{$t('word190',['电网功率'])}}</div>
									<div class="cMain">
										<span :title="convertData(Data.gridPower,2,'','W')[0]"><span class="fs16x">{{convertData(Data.gridPower,2,"","W")[1]}}</span>{{convertData(Data.gridPower,2,"","W")[2]}}</span>
									</div>
								</li>
							</ul>
							<ul >
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word501',['当日并网量'])">
										<span class="dpB">{{$t('word501',['当日并网量'])}}</span>
									</div>
									<div :title="convertData(Data.gridInterconnectionToday,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.gridInterconnectionToday,2,"k","Wh")[1]}}</span>{{convertData(Data.gridInterconnectionToday,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word503',['当月并网量'])">
										<span class="dpB">{{$t('word503',['当月并网量'])}}</span>
									</div>
									<div :title="convertData(Data.gridInterconnectionMonth,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.gridInterconnectionMonth,2,"k","Wh")[1]}}</span>{{convertData(Data.gridInterconnectionMonth,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant292','当季并网量')">
										<span class="dpB">{{getLanguageStr('plant292','当季并网量')}}</span>
									</div>
									<div :title="convertData(Data.gridInterconnectionQuarter,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.gridInterconnectionQuarter,2,"k","Wh")[1]}}</span>{{convertData(Data.gridInterconnectionQuarter,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word505',['当年并网量'])">
										<span class="dpB">{{$t('word505',['当年并网量'])}}</span>
									</div>
									<div :title="convertData(Data.gridInterconnectionYear,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.gridInterconnectionYear,2,"k","Wh")[1]}}</span>{{convertData(Data.gridInterconnectionYear,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word499',['累计并网量'])">
										<span class="dpB">{{$t('word499',['累计并网量'])}}</span>
									</div>
									<div :title="convertData(Data.gridInterconnectionUpload,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.gridInterconnectionUpload,2,"k","Wh")[1]}}</span>{{convertData(Data.gridInterconnectionUpload,2,"k","Wh")[2]}}</div>
								</li>
							</ul>
							<ul class="bdSub-bottom">
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word502',['当日购电量'])">
										<span class="dpB">{{$t('word502',['当日购电量'])}}</span>
									</div>
									<div :title="convertData(Data.purchaseQuantityToday,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.purchaseQuantityToday,2,"k","Wh")[1]}}</span>{{convertData(Data.purchaseQuantityToday,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word504',['当月购电量'])">
										<span class="dpB">{{$t('word504',['当月购电量'])}}</span>
									</div>
									<div :title="convertData(Data.purchaseQuantityMonth,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.purchaseQuantityMonth,2,"k","Wh")[1]}}</span>{{convertData(Data.purchaseQuantityMonth,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant293','当季购电量')">
										<span class="dpB">{{getLanguageStr('plant293','当季购电量')}}</span>
									</div>
									<div :title="convertData(Data.purchaseQuantityQuarter,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.purchaseQuantityQuarter,2,"k","Wh")[1]}}</span>{{convertData(Data.purchaseQuantityQuarter,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word506',['当年购电量'])">
										<span class="dpB">{{$t('word506',['当年购电量'])}}</span>
									</div>
									<div :title="convertData(Data.purchaseQuantityYear,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.purchaseQuantityYear,2,"k","Wh")[1]}}</span>{{convertData(Data.purchaseQuantityYear,2,"k","Wh")[2]}}</div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="$t('word500',['累计购电量'])">
										<span class="dpB">{{$t('word500',['累计购电量'])}}</span>
									</div>
									<div :title="convertData(Data.purchaseQuantityUpload,2,'k','Wh')[0]"><span class="fs12x">{{convertData(Data.purchaseQuantityUpload,2,"k","Wh")[1]}}</span>{{convertData(Data.purchaseQuantityUpload,2,"k","Wh")[2]}}</div>
								</li>
							</ul>
						</td>
					</tr>
					<tr >
						<td class="pt2x vaT vaM_E">
							<svg class="w3x h3x ml2x">
								<use xlink:href="#ico-income"></use>
							</svg>
						</td>
						<td>
							<ul class="bdSub-bottom">
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant294','当日预估收入')">
										<span class="dpB">{{getLanguageStr('plant294','当日预估收入')}}</span>
									</div>
									<div :title="floatFix(Data.incomeToday,2,' CNY')"><span class="fs12x">{{floatFix(Data.incomeToday,2)}}</span><span v-if="Data.incomeToday!=null">CNY</span></div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant295','当月预估收入')">
										<span class="dpB">{{getLanguageStr('plant295','当月预估收入')}}</span>
									</div>
									<div :title="floatFix(Data.incomeMonth,2,' CNY')"><span class="fs12x">{{floatFix(Data.incomeMonth,2)}}</span><span v-if="Data.incomeMonth!=null">CNY</span></div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant296','当季预估收入')">
										<span class="dpB">{{getLanguageStr('plant296','当季预估收入')}}</span>
									</div>
									<div :title="floatFix(Data.incomeQuarter,2,' CNY')"><span class="fs12x">{{floatFix(Data.incomeQuarter,2)}}</span><span v-if="Data.incomeQuarter!=null">CNY</span></div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant297','当年预估收入')">
										<span class="dpB">{{getLanguageStr('plant297','当年预估收入')}}</span>
									</div>
									<div :title="floatFix(Data.incomeYear,2,' CNY')"><span class="fs12x">{{floatFix(Data.incomeYear,2)}}</span><span v-if="Data.incomeYear!=null">CNY</span></div>
								</li>
								<li>
									<div class="cSub mr1x posR textCut_E ofV" :title="getLanguageStr('plant298','累计预估收入')">
										<span class="dpB">{{getLanguageStr('plant298','累计预估收入')}}</span>
									</div>
									<div :title="floatFix(Data.incomeUpload,2,' CNY')"><span class="fs12x">{{floatFix(Data.incomeUpload,2)}}</span><span v-if="Data.incomeUpload!=null">CNY</span></div>
								</li>
							</ul>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</WindowForView>
</template>
<script>
import * as lib from "@/util/lib.js";

import Loading from '@/components/common/ui/Loading';
import NoResult from '@/components/common/ui/NoResult';
import WindowForView from '@/components/common/ui/WindowForView';

import {getLanguageStr} from "@/util/language.js";

export default {
	components:{WindowForView},
	props:{
		Data:{
			type:Object,
		}
	},
	data(){
		return{
			id:"viewRealData"+Math.round(Math.random()*99999),
		}
	},
	mounted(){
		lib.setScroll($("#"+this.id+" [scroll]"));
	},
	methods:{
		getLanguageStr,
		floatFix:lib.floatFix,
		convertData:lib.convertData,
		open(){
			this.$refs.Window.show();
		},
		close(){
			this.$refs.Window.hide();
		}
	},
}
</script>
<style lang="scss" scoped>
table{
	width: auto;
	min-width: 60em;
}
.realTimeInfo ul > *{
	width: 20%
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/ViewRealData.vue